import React__default, { forwardRef } from 'react';
import { useToggleState } from 'react-stately';
import { useToggleButton } from 'react-aria';
import { UnstyledButton } from './UnstyledButton.js';
import { useRefObjectAsForwardedRef } from '../../hooks/useRefObjectAsForwardedRef.js';

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
/**
 *
 * Toggle buttons support a selection state that is toggled when a user presses the button.
 *
 * ToggleButton is an ecosystem-agnostic ToggleButton primitive, implemented using ARIA attributes.
 *
 */
const ToggleButton = /*#__PURE__*/forwardRef(({
  children,
  sx: sxProp,
  ...props
}, forwardedRef) => {
  const innerRef = React__default.useRef(null);
  const state = useToggleState(props);
  const {
    buttonProps,
    isPressed
  } = useToggleButton(props, state, innerRef);
  const {
    isDisabled,
    UNSAFE_className
  } = props;
  useRefObjectAsForwardedRef(forwardedRef, innerRef);
  return /*#__PURE__*/React__default.createElement(UnstyledButton, _extends({}, buttonProps, {
    sx: {
      backgroundColor: isPressed ? state.isSelected ? 'background.success.bold.default' : 'background.selected.default' : state.isSelected ? 'background.success.bold.default' : 'background.neutral.default.[default]',
      color: state.isSelected ? 'text.inverse' : isDisabled ? 'text.disabled' : 'text.default',
      padding: 1,
      userSelect: 'none',
      borderRadius: 1,
      WebkitUserSelect: 'none',
      border: 'none',
      ...sxProp
    },
    className: UNSAFE_className,
    ref: innerRef
  }, props), children);
});
ToggleButton.displayName = 'ToggleButton';
var ToggleButton$1 = ToggleButton;

export { ToggleButton$1 as default };
